<template>
  <div ref="view-page" style="height: 100%">
    <vab-only-office :option="option" />
  </div>
</template>
  <script>
import vabOnlyOffice from './onlyoffice/index.vue'
export default {
  components: {
    vabOnlyOffice,
  },
  props: {
    url: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      viewUrl: '',
      // 参考vabOnlyOffice组件参数配置
      option: {
        url: this.url,
        isEdit: false,
        fileType: '',
        title: '',
        lang: '',
        isPrint: false,
        user: { id: null, name: '' },
      },
    }
  },
  watch: {
    url: function (val) {
      this.getViewUrl(val)
      this.checkUrl()
    },
  },
  mounted() {
    this.getViewUrl(this.url)
  },
  methods: {
    checkUrl() {
      const allowedUrls = window.config.getsuccessUrl()
      const isValid = allowedUrls.some((allowedUrl) => this.url.startsWith(allowedUrl))
      if (!isValid) {
        // Show alert or modal dialog
        // alert('URL is not allowed!')
        this.$refs['view-page'].innerHTML = '非法url'
      }
    },
    getViewUrl(url) {
      this.option = {
        url: url,
        isEdit: false,
        fileType: '',
        // title: this.name ? this.name : this.$util.getFileName(url),
        title: '在线预览',
        lang: '',
        isPrint: '',
        // user: { id: null, name: this.$store.state.user.userInfo.userName },
        user: { id: null },
      }
    },
  },
}
</script>
